import { AppLogo } from '@/components/layout/AppLogo';
import { cn } from '@/lib/utils';

/**
 * The app mark with a ring turning around it: the page loading indicator.
 * Decorative; the caller gives the status its accessible name.
 */
export function LogoSpinner({ className }: { className?: string }) {
	return (
		<span
			aria-hidden="true"
			className={cn(
				'relative flex size-16 items-center justify-center',
				className,
			)}
		>
			<span className="border-primary/15 border-t-primary absolute inset-0 animate-spin rounded-full border-[3px] motion-reduce:animate-[spin_1.5s_linear_infinite]" />
			<AppLogo className="size-9" />
		</span>
	);
}
